import { render, staticRenderFns } from "./editorXlsx.vue?vue&type=template&id=0b842f78&scoped=true&"
import script from "./editorXlsx.vue?vue&type=script&lang=js&"
export * from "./editorXlsx.vue?vue&type=script&lang=js&"
import style0 from "./editorXlsx.vue?vue&type=style&index=0&lang=less&"
import style1 from "./editorXlsx.vue?vue&type=style&index=1&id=0b842f78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b842f78",
  null
  
)

export default component.exports